<script>
    // $design resolves to lib/design/classic or lib/design/redesign at build
    // time (VITE_TAP_REDESIGN, see vite.config.js).
    import Layout from '$design/Layout.svelte';

    let { children } = $props();
</script>

<Layout>
    {@render children?.()}
</Layout>
